import Storage  from "./Storage";


async function setAuthToken  (token) {
    try {
        /* console.log(token); */
        Storage.setItem("user_session", token);
    } catch (error) {
        console.log(error.code);
    }
};

async function getAuthToken (){
    try {
        const userObjectString = await Storage.getItem("user-object");
        if(userObjectString) {
            const userObject = JSON.parse(userObjectString);
            return userObject.AccessToken
        }
       
    } catch (error) {
        console.log(error.code);
    }
};

async function clearAuthToken () {
    try {
        Storage.clearItem("user_session");
    } catch (error) {
        console.log(error.code);
    }
};

const Auth = {
    setAuthToken,
    getAuthToken,
    clearAuthToken,
};
  
export default Auth;